import axios from 'axios';
import { backendBaseUrl5 } from './config';
const registerApi = axios.create({
    baseURL: `${backendBaseUrl5}register/`,
});

export function register(username, email, gametoken) {
    return new Promise((resolve, reject) => {
        const formdata = {
            userName: username,
            userEmail: email,
            gametoken: gametoken,
        };
        registerApi
            .get('RegisterUser', { params: formdata })
            .then((axResult) => {
                if (axResult?.data?.responsecode === 0) {
                    resolve(axResult.data.data);
                } else if (axResult?.data?.responsemsg) {
                    reject(new Error(axResult.data.responsemsg));
                } else {
                    reject(new Error(`Error while retrieving game`));
                }
            })
            .catch((axiosError) => {
                console.log('register axiosError:', axiosError);
                reject(JSON.stringify(axiosError, null, 4));
            });
    });
}

export function confirmRegistration(token) {
    return new Promise((resolve, reject) => {
        const formdata = {
            token,
        };
        registerApi
            .get('', { params: formdata })
            .then((axResult) => {
                if (
                    axResult?.data?.responsecode === 0 ||
                    ((axResult?.status === 200 || axResult?.status === '200') &&
                        !axResult?.data?.responsecode)
                ) {
                    resolve(axResult.data.data);
                } else if (axResult?.data?.responsemsg) {
                    reject(new Error(axResult.data.responsemsg));
                } else {
                    reject(new Error(`Error while retrieving game`));
                }
            })
            .catch((axiosError) => {
                console.log('register axiosError:', axiosError);
                reject(JSON.stringify(axiosError, null, 4));
            });
    });
}
// /student/confirm-registration
// http://localhost:3002/#/student/confirm-registration?token=FsHY9M+l3vuNmYSWGCVKgUHn7NVMoKuXAqCE3k29x3zGhrrO5QK7JBc3TrZ+kAsSc43MxkuIO8sB6yvc+M8TslSbHr04wEefDBVne5dM/Dkml+yIWATr9+FqX+g5xga3NudcnaVS5Cgp6gCtGWGyvWE4nRYrFkfncCjI3MWsby39vW3Gjd+Ig7g8wg9FZeHWrpoXwc19YziRdIBocY6FdQ==
//https://www.digigreenhouse.wur.nl/edu/kassimPro/RegisterUser.aspx?token=FsHY9M+l3vuNmYSWGCVKgUHn7NVMoKuXAqCE3k29x3zGhrrO5QK7JBc3TrZ+kAsSc43MxkuIO8sB6yvc+M8TslSbHr04wEefDBVne5dM/Dkml+yIWATr9+FqX+g5xga3NudcnaVS5Cgp6gCtGWGyvWE4nRYrFkfncCjI3MWsby39vW3Gjd+Ig7g8wg9FZeHWrpoXwc19YziRdIBocY6FdQ==
